import { SaleOfferLine } from './sale-offer-line';

export const STATUS_SENT = 1;
export const STATUS_ACCEPTED = 2;
export const VAT_VALUE = 21;
export const IS_DEPOSIT = 1;
export const NOT_DEPOSIT = 0;

export class SaleOffer {
  constructor(
    public hash?: string,
    public offerDate?: number,
    public customerHash?: string,
    public saleOrderHash?: string,
    public customerBusinessName?: string,
    public customerTradeName?: string,
    public traderHash?: string,
    public traderFirstName?: string,
    public traderLastName?: string,
    public offerNumber?: number,
    public observations?: string,
    public additionalData?: string,
    public internalObservations?: string,
    public offerObservations?: string,
    public paymentMethodHash?: string,
    public paymentMethodDescription?: string,
    public subTotalAmount?: number,
    public vat?: number,
    public totalVat?: number,
    public totalAmount?: number,
    public status?: number,
    public isPendingStepFinished?: boolean,
    public isInvoiceStepFinished?: boolean,
    public isDepartureStepFinished?: boolean,
    public isPreparationStepFinished?: boolean,
    public isPostageStepFinished?: boolean,
    public isControlDocumentStepFinished?: boolean,
    public sentByEmailDate?: number,
    public signedByCustomerDate?: number,
    public personWhoIsGoingToSign?: string,
    public saleOfferDepartureHash?: string,
    public saleOfferPreparationHash?: string,
    public saleOfferBearingHash?: string,
    public saleOfferControlDocumentHash?: string,
    public saleOfferLines?: SaleOfferLine[],
    public isDeposit?: boolean,
    public saleOfferKeyCode?: string
  ) { }

  get traderFullName() {
    return `${ this.traderFirstName } ${ this.traderLastName }`;
  }

  get isStatusSent() {
    return this.status === STATUS_SENT;
  }

  get isStatusAccepted() {
    return this.status === STATUS_ACCEPTED;
  }

  clone() {
    return new SaleOffer(
      this.hash,
      this.offerDate,
      this.customerHash,
      this.saleOrderHash,
      this.customerBusinessName,
      this.customerTradeName,
      this.traderHash,
      this.traderFirstName,
      this.traderLastName,
      this.offerNumber,
      this.observations,
      this.additionalData,
      this.internalObservations,
      this.offerObservations,
      this.paymentMethodHash,
      this.paymentMethodDescription,
      this.subTotalAmount,
      this.vat,
      this.totalVat,
      this.totalAmount,
      this.status,
      this.isPendingStepFinished,
      this.isInvoiceStepFinished,
      this.isDepartureStepFinished,
      this.isPreparationStepFinished,
      this.isPostageStepFinished,
      this.isControlDocumentStepFinished,
      this.sentByEmailDate,
      this.signedByCustomerDate,
      this.personWhoIsGoingToSign,
      this.saleOfferDepartureHash,
      this.saleOfferPreparationHash,
      this.saleOfferBearingHash,
      this.saleOfferControlDocumentHash,
      this.saleOfferLines,
      this.isDeposit,
      this.saleOfferKeyCode
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer.ts